import { List } from 'antd'
import React from 'react'
import GradingCard from './GradingCard'
import { getAnswerByQuestion } from '../../../../../../../../../../utils/question.helper'

const ComplexQuestionGradingCardList = ({ submissionId, question, answers }) => {
    return (
        <List
            dataSource={question.children}
            renderItem={question => (
                <GradingCard
                    className='mb-8'
                    submissionId={submissionId}
                    answer={getAnswerByQuestion(answers, question)}
                    question={question}
                />
            )}
        />
    )
}

export default ComplexQuestionGradingCardList
